import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/retail-app/performing-retail-back.webp";

function Milliondollarapp() {
  return (
    <section
      className="million_dollar_app retail_performing text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Build High-<span>Performing</span> Retail Apps
            </h2>
            <p>
              Develop fast, responsive apps that handle high traffic and deliver
              seamless shopping experiences.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Build My Retail App
            </Link>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="offset-md-1">
            <div className="million-dollar-img">
              <StaticImage
                src="../../images/services-usa/retail-app/performing-retail.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={742}
                height={729}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Milliondollarapp;
